import { Component } from '@angular/core';

@Component({
  selector: 'app-no-permission',
  templateUrl: './no-permission.component.html'
})
export class NoPermissionComponent { }
